var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 29,
    viewBox: "0 0 28 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.8667 25.2717L15.5167 17.9217C14.9333 18.3884 14.2625 18.7578 13.5042 19.0301C12.7458 19.3023 11.9389 19.4384 11.0833 19.4384C8.96389 19.4384 7.17033 18.7042 5.70267 17.2357C4.235 15.7673 3.50078 13.9737 3.5 11.8551C3.5 9.73562 4.23422 7.94206 5.70267 6.4744C7.17111 5.00673 8.96467 4.27251 11.0833 4.27173C13.2028 4.27173 14.9963 5.00595 16.464 6.4744C17.9317 7.94284 18.6659 9.73639 18.6667 11.8551C18.6667 12.7106 18.5306 13.5176 18.2583 14.2759C17.9861 15.0342 17.6167 15.7051 17.15 16.2884L24.5 23.6384L22.8667 25.2717ZM11.0833 17.1051C12.5417 17.1051 13.7814 16.5945 14.8027 15.5732C15.8239 14.552 16.3341 13.3126 16.3333 11.8551C16.3333 10.3967 15.8227 9.15695 14.8015 8.13573C13.7803 7.11451 12.5409 6.60428 11.0833 6.60506C9.625 6.60506 8.38522 7.11567 7.364 8.1369C6.34278 9.15812 5.83256 10.3975 5.83333 11.8551C5.83333 13.3134 6.34394 14.5532 7.36517 15.5744C8.38639 16.5956 9.62578 17.1058 11.0833 17.1051Z",
    fill: "#2248B8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.601e7c879af2bde6ac1049a897250275.svg";
export { ForwardRef as ReactComponent };